module.exports = __webpack_public_path__ + "img/172-st-lucia.761f4ae3.svg";